var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 54.5,
    height: 54.5,
    fill: "#FAF8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 54.5,
    height: 54.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7026_6973)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    transform: "translate(6 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5727 20.4273C32.6849 18.5396 30.1732 17.5 27.5 17.5C24.8268 17.5 22.3151 18.5396 20.4273 20.4273C18.5396 22.3151 17.5 24.8269 17.5 27.5C17.5 30.1731 18.5396 32.6849 20.4273 34.5727C22.3151 36.4604 24.8268 37.5 27.5 37.5C30.1732 37.5 32.6849 36.4604 34.5727 34.5727C36.4604 32.6849 37.5 30.1731 37.5 27.5C37.5 24.8269 36.4604 22.3151 34.5727 20.4273ZM27.5 36.2629C22.6681 36.2629 18.7371 32.3319 18.7371 27.5C18.7371 22.6681 22.6681 18.7371 27.5 18.7371C32.3319 18.7371 36.2629 22.6681 36.2629 27.5C36.2629 32.3319 32.3319 36.2629 27.5 36.2629Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9884 23.0201C30.7916 21.8232 29.199 21.1641 27.5043 21.1641C25.8095 21.1641 24.217 21.8232 23.0201 23.0201C21.8232 24.217 21.1641 25.8095 21.1641 27.5043C21.1641 29.199 21.8232 30.7916 23.0201 31.9884C24.217 33.1853 25.8095 33.8445 27.5043 33.8445C29.199 33.8445 30.7916 33.1853 31.9884 31.9884C33.1853 30.7916 33.8445 29.199 33.8445 27.5043C33.8445 25.8095 33.1853 24.217 31.9884 23.0201ZM27.5043 32.6074C24.6904 32.6074 22.4012 30.3181 22.4012 27.5043C22.4012 24.6904 24.6904 22.4012 27.5043 22.4012C30.3181 22.4012 32.6074 24.6904 32.6074 27.5043C32.6074 30.3181 30.3181 32.6074 27.5043 32.6074Z",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5085 24.8164C26.0306 24.8164 24.8281 26.0188 24.8281 27.4968C24.8281 28.9748 26.0306 30.1772 27.5085 30.1772C28.9865 30.1772 30.1889 28.9748 30.1889 27.4968C30.1889 26.0188 28.9865 24.8164 27.5085 24.8164Z",
    fill: "#0A0A0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7026_6973",
    x: 4,
    y: 6,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7026_6973"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7026_6973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7026_6973",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.f4aaf276bb3349feac1e5112b5df016a.svg";
export { ForwardRef as ReactComponent };